import { XIcon } from "lucide-react";

type FilterPanelHeaderProps = {
  onClear: () => void;
  onClose: () => void;
};

export const FilterPanelHeader = ({ onClear, onClose }: FilterPanelHeaderProps) => (
  <div className="flex items-center justify-between px-6 py-4">
    <button
      type="button"
      onClick={onClear}
      className="text-sm font-medium text-tertiary hover:text-primary transition-colors"
    >
      Clear all
    </button>
    <button
      type="button"
      onClick={onClose}
      className="flex items-center gap-2 p-1 rounded-md hover:bg-secondary transition-colors"
    >
      <span className="text-sm font-medium text-primary">Close</span>
      <XIcon className="w-4 h-4 text-tertiary" />
    </button>
  </div>
);
